/*@ngInject*/
const UMDropdownListItemScrollIntoViewDirective = function () {

    let linkFunction = function ($scope, $elm, $attrs) {

        const element = $($elm);
        const listElement = $('um-dropdown-list');

        $scope.$watch('item.highlighted', function (newValue, oldValue) {
            if (!$scope.item.mouseOver) {
                if (!_.isNil(newValue) && !_.isNil(oldValue) && newValue === true && oldValue === false) {

                    const listBoundingClientRect = listElement[0].getBoundingClientRect();
                    const elementBoundingClientRect = element[0].getBoundingClientRect();

                    if (shouldScrollIntoViewTop(listBoundingClientRect, elementBoundingClientRect)) {
                        listElement.animate({
                            scrollTop: listElement.scrollTop() + elementBoundingClientRect.top - listBoundingClientRect.top
                        }, 0);
                    } else if (shouldScrollIntoViewBottom(listBoundingClientRect, elementBoundingClientRect)) {
                        listElement.animate({
                            scrollTop: listElement.scrollTop() + elementBoundingClientRect.bottom - listBoundingClientRect.bottom
                        }, 0);
                    }
                }
            }
        });

        function shouldScrollIntoViewTop(listBoundingClientRect, elementBoundingClientRect) {
            return elementBoundingClientRect.top < listBoundingClientRect.top;
        }

        function shouldScrollIntoViewBottom(listBoundingClientRect, elementBoundingClientRect) {
            return elementBoundingClientRect.bottom > listBoundingClientRect.bottom;
        }
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('umDropdownListItemScrollIntoView', UMDropdownListItemScrollIntoViewDirective);
